export function loopifyN<T>(arr: T[], loops: number = 1): T[] {
  if (arr.length <= 1) return arr

  const result = [...arr]
  const middle = arr.slice(1, -1).reverse()

  for (let i = 0; i < loops; i++) {
    result.push(...middle, ...arr)
  }

  return result
}
